// extracted by mini-css-extract-plugin
export var dividerContainer = "_75-0";
export var line = "_75-1";